export default __webpack_public_path__ + "static/media/PC-06.f3dbfd42.jpg";